import React from 'react';
import styles from '../../styles/Sidebar.module.css';
import { useSidebar } from '../../contexts/SidebarContext';
import { useNavigate } from 'react-router-dom';

// Support for footer items
const Sidebar: React.FC = () => {
  const {
    isOpen,
    toggleSidebar,
    items,
    activeItem,
    setActiveItem,
    footerItems,
    removeSidebar,
    openSidebar
  } = useSidebar();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (items.length === 0 && footerItems.length === 0) {
      removeSidebar();
    } else if (isOpen === null) {
      openSidebar();
    }
  }, [items.length, footerItems.length, isOpen, removeSidebar, openSidebar]);

  if (items.length === 0 && footerItems.length === 0) {
    return null;
  }
  return (
    <div className={`${styles.sidebar} ${!isOpen ? styles.collapsed : ''}`}>
      <div className={styles.sidebarHeader}>
        <button
          className={styles.toggleButton}
          onClick={toggleSidebar}
          aria-label={isOpen ? 'Collapse sidebar' : 'Expand sidebar'}
        >
          {isOpen ? '←' : '→'}
        </button>
      </div>
      <nav className={styles.sidebarNav}>
        {items.map((item) => (
          <button
            key={item.id}
            className={`${styles.sidebarItem} ${
              activeItem === item.id ? styles.active : ''
            }`}
            onClick={() => {
              setActiveItem(item.id);
              if (item.to) navigate(item.to);
              if (item.onClick) item.onClick();
            }}
          >
            {item.icon && (
              <span className={styles.itemIcon}>{item.icon}</span>
            )}
            {isOpen && (
              <span className={styles.itemLabel}>{item.label}</span>
            )}
          </button>
        ))}
      </nav>
      {footerItems.length > 0 && (
        <div className={styles.sidebarFooter}>
          {footerItems.map((item) => (
            <button
              key={item.id}
              className={styles.sidebarItem}
              onClick={() => {
                if (item.to) navigate(item.to);
                if (item.onClick) item.onClick();
              }}
            >
              {item.icon && (
                <span className={styles.itemIcon}>{item.icon}</span>
              )}
              {isOpen && (
                <span className={styles.itemLabel}>{item.label}</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Sidebar;
